import {
    createObjectField,
    createPrimitiveField,
    type InferFieldValue,
    type ValidationError,
} from '@adv-frontend/form-kit';

export const fieldSelfPickUpAddress = createObjectField({
    fields: {
        pickUpWarehouseId: createPrimitiveField({ defaultValue: '' }),
        address: createPrimitiveField({ defaultValue: '' }),
        locality: createPrimitiveField({ defaultValue: '' }),
    },
    validators: (createValidators) => createValidators<ValidationError<'REQUIRED_DELIVERY_ADDRESS'>>({}),
});

export type SelfPickUpAddressFieldValue = InferFieldValue<typeof fieldSelfPickUpAddress>;
